class SearchBarInline extends HTMLElement {
  connectedCallback() {
    const raw = this.dataset.keywords || '';
    this.words = raw
      .split(',')
      .map((word) => word.trim())
      .filter(Boolean);
    this.target = this.querySelector('[ref="placeholderWord"]');
    this.index = 0;

    if (this.words.length === 0 || !this.target) return;

    this.render();

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.words.length > 1 && !prefersReducedMotion) {
      this.timer = setInterval(() => this.next(), 2600);
    }
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  render() {
    this.target.textContent = this.words[this.index];
  }

  next() {
    this.target.style.opacity = '0';
    window.setTimeout(() => {
      this.index = (this.index + 1) % this.words.length;
      this.render();
      this.target.style.opacity = '1';
    }, 200);
  }
}

if (!customElements.get('search-bar-inline')) {
  customElements.define('search-bar-inline', SearchBarInline);
}
